(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dataLoader.worker", [], factory);
	else if(typeof exports === 'object')
		exports["dataLoader.worker"] = factory();
	else
		root["dataLoader.worker"] = factory();
})(self, () => {
return 